<footer class="footer bg-dark text-center">
  <div class="container">
    <p>
      &copy; 2020 {{allyName}}
    </p>
  </div>
</footer>
